export const getLoginRouteWithRedirect = (url = '') => {
  if (url) return `/login?redirect=${url}`;
  return `/login`;
};
